import { useMemo } from 'react';

import { capitalizeFirstCharLowerOthers } from '@utils/formatting-utils';
import { lookupListAsRecordObject } from '@utils/graph-utils';

import { useGetMedicalLovs } from '../proposal.slice';

type MedicalLovs = {
  classes: Record<string, string>;
  levels: Record<string, string>;
  nssf: Record<string, string>;
  covers: Record<string, string>;
};

export function useMedicalLovs(isMedical: boolean): MedicalLovs {
  const { data } = useGetMedicalLovs({ skip: !isMedical });

  return useMemo(() => {
    const classes = lookupListAsRecordObject(
      data?.planConfig?.getMedicalClasses
    );
    const levels = lookupListAsRecordObject(data?.planConfig?.getMedicalLevels);
    const nssfRaw = data?.CoNSSFList?.enumValues ?? [];
    const nssf: Record<string, string> = nssfRaw
      .map((g) => g?.name)
      .filter((s): s is string => Boolean(s))
      .reduce(
        (acc, curr) => {
          acc[curr] = capitalizeFirstCharLowerOthers(curr);

          return acc;
        },
        {} as Record<string, string>
      );

    return { classes, levels, nssf, covers: {} };
  }, [data]);
}
